<template>
  <v-app-bar
    v-if="responsive"
    id="core-app-bar"
    absolute
    app
    color="grey darken-4"
    flat
    height="88"
    class="top-app-bar"
  >
    <v-toolbar-title class="font-weight-light align-self-center">
      <v-btn
        dark
        icon
        @click.stop="onClick"
      >
        <v-icon>mdi-view-list</v-icon>
      </v-btn>
    </v-toolbar-title>

    <v-spacer />
  </v-app-bar>
</template>

<script>
  // Utilities
  import {
    mapMutations
  } from 'vuex'

  export default {
    data: () => ({
      notifications: [
        'Mike, John responded to your email',
        'You have 5 new tasks',
        'You\'re now a friend with Andrew',
        'Another Notification',
        'Another One'
      ],
      title: null,
      responsive: false
    }),

    watch: {
      '$route' (val) {
        this.title = val.name
      }
    },

    mounted () {
      this.onResponsiveInverted()
      window.addEventListener('resize', this.onResponsiveInverted)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onResponsiveInverted)
    },

    methods: {
      ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
      onClick () {
        this.setDrawer(!this.$store.state.app.drawer)
      },
      onResponsiveInverted () {
        if (window.innerWidth < 1263) {
          this.responsive = true
        } else {
          this.responsive = false
        }
      }
    }
  }
</script>

<style>
  /* Fix coming in v2.0.8 */
  #core-app-bar {
    width: auto;
  }

  #core-app-bar a {
    text-decoration: none;
  }

  .top-app-bar {
      display: none;
  }

  .v-content {
    padding-top: 0px !important;
    transition: padding-top 0.3s ease;
  }

  @media only screen and (max-width: 1263px) {
    .top-app-bar {
      display: block;
    }

    .v-content {
      padding-top: 88px !important;
    }
  }
</style>
